import React from 'react';
import { useSelector } from 'react-redux'

import PageScreen from '../../../components/organisms/Page/PageScreen'
import Paragraph from '../../../components/atoms/Paragraph/Paragraph'
import AppButton from '../../../components/atoms/AppButton/AppButton'
import { UI_BUTTON_TYPE } from '../../../components/atoms/AppButton/AppButtonProps'
import { AppLinks } from '../../../environment/app-links'
import analyticsService from '../../../service/analytics.service'
import { apphistory, AppState } from '../../../store'
import { PredefinedOfferDetailsModal, PredefinedOfferPageSingleOffer } from '../PredefinedOfferPage'
import { IPredefinedOfferDetails } from '../PredefinedOfferPageProps'
import usePredefinedOfferPageLogic from '../hooks/usePredefinedOfferPageLogic'
import useTextContents from '../../../hooks/useTextContents'
import { IPredefinedSingleOfferResponse } from '../../../store/types'

import '../PredefinedOfferPageStyles.scss'


const PredefinedOfferDefaultPageContent = () => {
   const textContent = useTextContents()

   const { predefinedUserOffersArray: predefinedOffersData} = useSelector((state: AppState) => state.offertState)
   const HAS_NO_OFFERS = predefinedOffersData === undefined || predefinedOffersData.length === 0

   const { 
      currentSelectedOffer, isMenuOpen, ANALYTICS_EVENT_TYPES_NAMES, 
      handleOnOfferClick, handleSubmitPredefinedOffer, handleToggleMenuOpen,  
   } = usePredefinedOfferPageLogic({ predefinedOffersData })



   if(HAS_NO_OFFERS) {
      return null
   }


   return (
      <PageScreen title={{title: textContent('predefinedOfferPage.heading'), line: true}}>
         <div className='predefined-offer-page-container' id="predefined-offer-page-container">
            <Paragraph>{textContent('predefinedOfferPage.mainContent')}</Paragraph>
            <div className='predefined-offer-page-offers-container'>
               {
                  predefinedOffersData.map((singleOffer: IPredefinedSingleOfferResponse, index: number) => {
                     return <PredefinedOfferPageSingleOffer key={`predefined-single-offer-${index}`} handleOnOfferClick={handleOnOfferClick} {...singleOffer} textContent={textContent} />
                  })
               }
            </div>
            <AppButton
               uiButtonType={UI_BUTTON_TYPE.PRIMARY_OUTLINE}
               onClick={async() => {
                  await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.CustomUserOfferPageDisplayed)
                  apphistory.push(AppLinks.customOffer)
               }}>
               {textContent('buttons.predefinedOfferChooseCustomOffer')}
            </AppButton>
            {currentSelectedOffer !== undefined && (
               <PredefinedOfferDetailsModal
                  isMenuOpen={isMenuOpen}
                  isLoading={false}
                  setIsMenuOpen={handleToggleMenuOpen}
                  handleOnDialogConfirm={handleSubmitPredefinedOffer}
                  textContent={textContent}
                  {...currentSelectedOffer as IPredefinedOfferDetails}    
               />
            )}
         </div>
      </PageScreen>
   )
}

export default PredefinedOfferDefaultPageContent